<template>
	<!-- 请假申请 -->
	<div>
		<div v-show="Qjsq">
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">请假申请</div>
			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px">
				<!-- 查询框 -->
				<div style="margin-left:3%">
					<div style="height:10px"></div>
					<div style="display:inline-block;margin-top:20px">
						<span>组织架构</span>
						<el-cascader v-model="condition.organize_ids" clearable
							style="margin-left:10px;width:220px" collapse-tags :props="props"></el-cascader>
					</div>

					<div style="display:inline-block;margin-left:10px">
						<span>城市 </span>
						<el-select v-model="condition.sign_post" style="margin-left:10px;width:140px"
							:placeholder="postPlaceholder" clearable>
							<el-option v-for="item in postList" :key="item.id" :label="item.post_name" :value="item.id">
							</el-option>
						</el-select>
					</div>

					<div style="display:inline-block;margin-left:10px">
						<span>请假时间 </span>
						<el-date-picker style="width:150px;margin-left:10px" v-model="condition.start_date"
							type="datetime" placeholder="请选择" value-format="yyyy-MM-dd">
						</el-date-picker>
					</div>

					<div style="display:inline-block;margin-left:10px">
						<span>姓名 </span>
						<el-input v-model="condition.partner_name" style="margin-left:10px;width:140px"
							placeholder="请输入姓名">
						</el-input>
					</div>

					<div style="display:inline-block;margin-left:10px">
						<span>状态 </span>
						<el-select v-model="condition.is_signContract" style="margin-left:10px;width:140px"
							placeholder="请选择" clearable>
							<el-option v-for="item in ztList" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</div>

					<!-- 按钮 -->
					<div style="display:inline-block;margin:20px 50px;float:right">
						<el-button type="goon" @click="Find">查询</el-button>
						<el-button type="goon" @click="Del(null)">删除</el-button>
						<el-button type="addbtn" @click="add">新增</el-button>
					</div>
				</div>

				<!-- 表格 -->
				<div style="margin:2% 3% 0 3%">
					<el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
						:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
						style="width: 100%;" height="560" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55">
						</el-table-column>
						<el-table-column align="center" label="序号" width="50">
							<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
						</el-table-column>
						<el-table-column align="center" label="组织架构" width="300">
							<template slot-scope="scope">
								{{$globals.group_name + "/" + scope.row.staff.range}}
							</template>
						</el-table-column>
						<el-table-column prop="staff.city_id" align="center" label="城市"></el-table-column>
						<el-table-column prop="staff.post_name" align="center" label="职位"></el-table-column>
						<el-table-column prop="staff.staff_name" align="center" label="姓名"></el-table-column>
						<el-table-column prop="staff.staff_card" align="center" label="身份证号码"></el-table-column>
						<el-table-column prop="staff.staff_telephone" align="center" label="手机号"></el-table-column>
						<el-table-column prop="dictionaries_data" align="center" label="请假类型"></el-table-column>
						<el-table-column prop="start_date" align="center" label="开始时间"></el-table-column>
						<el-table-column prop="end_date" align="center" label="结束时间"></el-table-column>
						<el-table-column prop="leave_duration" align="center" label="请假时长(小时)"></el-table-column>
						<el-table-column prop="leave_reason" align="center" label="请假事由"></el-table-column>
						<el-table-column prop="leave_url" align="center" label="照片" width=100>
							<template slot-scope="scope">
								<el-button type="pic">查看照片</el-button>
							</template>
						</el-table-column>
						<el-table-column prop="" align="center" label="状态" width=100>
							<template slot-scope="scope">
								<img src="../../../assets/待审批.png" v-show="scope.row.template_state === '0'" />
								<img src="../../../assets/已同意.png" v-show="scope.row.template_state === '3'" />
								<img src="../../../assets/stateImg/状态_已驳回.png"
									v-show="scope.row.template_state === '1'" />
							</template>
						</el-table-column>
						<el-table-column align="center" label="操作" width="150" fixed="right">
							<template slot-scope="scope">
								<img src="../../../assets/编辑.png" @click="bianji(scope.row)">
								<img src="../../../assets/删除.png" @click="Del(scope.row.id)">
							</template>
						</el-table-column>
					</el-table>

					<!-- 分页 -->
					<el-row style="margin-top: 10px; text-align: center;">
						<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
							layout=" prev, pager, next, jumper" :total="total">
						</el-pagination>
					</el-row>
				</div>

			</div>
		</div>
		<add ref="add" :organizeList="organizeList" :qjList="qjList" v-show="showadd"></add>
	</div>
</template>

<script>
	import add from './Qjsq_add.vue';
	import axios from 'axios';
	export default {
		components: {
			add: add,
		},
		data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
			return {
				//列表相关
				page_num: 1,
				page_size: 10,
				total: 0,
				tableData: [],

				//条件
				condition: {
					id: '',
					organize_ids: [],
					dictionaries_name: '',
					start_date: '',
					end_date: '',
				},

				//详情
				ruleForm: {
					id: '',
					staff_id: '',
					staff_name: '',
					dictionaries_id: '',
					start_date: '',
					end_date: '',
					leave_duration: '',
					leave_reason: '',
					leave_url: '',
					staff: {
						staff_name: '',
						staff_card: '',
						staff_telephone: '',
						project_name: '',
						company_name: '',
						modular_name: '',
						city_id: '',
						post_name: '',
					},
					examineDetailsList: [],
				},

				//删除ids
				ids: [],

				// 权限
				Qjsq: true,
				
				//页面相关
				showadd: false,

				//状态数据
				ztList: [{
						value: '0',
						label: '待审批',
					},
					{
						value: '1',
						label: '已同意',
					},
					{
						value: '2',
						label: '已驳回',
					},
				],

				//组织架构数据
				organizeList: [],

				//级联下拉配置
				props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
					value: "id",
					label: "organize_name",
					children: "organizeList",
					checkStrictly: true,
					multiple: true,
				},
			};
		},
		methods: {
			// 列表复选框
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach((item) => {
					this.ids.push(item.id);
				});
			},
			// 返回
			Return() {
				this.showadd = false;
				this.Qjsq = true;
				this.Find();
			},
			// 新增
			add() {
				this.Qjsq = false;
				this.showadd = true;
			},
			// 操作详情
			bianji(e) {
				this.Qjsq = false;
				this.showadd = true;
				this.ruleForm.id = e.id;
				this.ruleForm.staff_name = e.staff.staff_name;
				this.ruleForm.staff_id = e.staff_id;
				this.ruleForm.dictionaries_id = e.dictionaries_id;
				this.ruleForm.start_date = e.start_date;
				this.ruleForm.end_date = e.end_date;
				this.ruleForm.leave_duration = e.leave_duration;
				this.ruleForm.leave_reason = e.leave_reason;
				this.ruleForm.leave_url = e.leave_url;
			},
			//查询
			async Find() {
				var temporary = [];
				this.condition.organize_ids.forEach(item => {
					temporary.push(item[item.length - 1]);
				})
				var organize_ids = "";
				temporary.forEach(item => {
					organize_ids += item + ",";
				})

				var url = '/StaffLeave/selectAll';
				var record = {
					page_num: this.page_num,
					page_size: this.page_size,
					data_grouping: 'Wcsq',
					organize_ids: organize_ids,
					city_id: this.condition.city_id,
					staff_name: this.condition.staff_name,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			// 操作删除
			async Del(e) {
				var ids;
				if (e === null || e === '' || e === undefined) {
					if (this.ids === null || this.ids.length <= 0) {
						this.$message.warning('请先选择操作数据！');
						return false;
					}
					ids = this.ids;
				} else {
					ids = [e];
				}
				
				var url = '/StaffLeave/del';
				var record = {
					ids: ids,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.trash();
						this.Find();
					} else {
						this.$message.warning(data);
					}
				}
			},
			//分页
			handleCurrentChange(val) {
				this.page_num = val;
				this.Find();
			},
			//清除数据
			trash() {
				this.ruleForm.id = '';
				this.ruleForm.dictionaries_id = '';
				this.ruleForm.start_date = '';
				this.ruleForm.end_date = '';
				this.ruleForm.leave_duration = '';
				this.ruleForm.leave_reason = '';
				this.ruleForm.leave_url = '';
				this.ruleForm.applicant_id = '';
				this.ruleForm.examineDetailsList = [];
			},
			//初始化组织架构及下面的人
			async organizeFind() {
				var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
					identification: "1"
				});
				this.organizeList = this.getTreeData(organizeList.data);

			},
			getTreeData(data) {
				// 循环遍历json数据
				for (var i = 0; i < data.length; i++) {

					if (data[i].organizeList.length < 1) {
						// children若为空数组，则将children设为undefined
						data[i].organizeList = undefined;
					} else {
						// children若不为空数组，则继续 递归调用 本方法
						this.getTreeData(data[i].organizeList);
					}
				}
				return data;
			}
		},
		async created() {
			this.Find();
			this.organizeFind();
			// 请假类型
			var qjList = await this.$globals.AxiosPost('/dictionaries/selectFind', {
				data_grouping: 'leave_type ',
			});
			this.qjList = qjList.data;
		},
	};
</script>

<style>
	.el-button--goon:focus,
	.el-button--goon:hover {
		background: #006e4b;
		border-color: #05573d;
		color: #fff;
	}

	.el-button--addbtn:focus,
	.el-button--addbtn:hover {
		background: #fff;
		border-color: #05573d;
		color: #006e4b;
	}

	.el-button--goon {
		color: #fff;
		background-color: #006e4b;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-button--addbtn {
		color: #006e4b;
		background-color: #fff;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-table .warning-row {
		background: oldlace;
	}

	.el-table .success-row {
		background: #f0f9eb;
	}

	.el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #006e4b;
		border-color: #006e4b;
	}

	.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #006e4b;
	}

	.el-checkbox__inner:hover {
		border-color: #006e4b;
	}

	.el-button--pic {
		color: #006e4b;
		background-color: #fff;
		border-color: #006e4b;
		font-size: 10px;
		height: 30px;
		width: 70px;
		padding: 10px;
	}

	.el-button--pic:focus,
	.el-button--pic:hover {
		background: #fff;
		border-color: #05573d;
		color: #006e4b;
	}
</style>



// WEBPACK FOOTER //
// Qjsq.vue?1cdaa0c4